<template>
  <div class="w-100">
    <section class="w-100 position-relative">
      <img
        src="https://cdn.vexels.com/img/purchase-plan-banner.jpg"
        loading="lazy"
        :alt="$t('main.purchasePlan.id.bannerAlt')"
        class="banner-img position-absolute h-50 w-100"
      />
      <b-container class="banner-container position-relative">
        <div class="text-container">
          <div class="title-container">
            <h2 v-if="openPlan" class="title">{{ openPlan.name }}&nbsp;</h2>
            <Badges
              v-if="openPlan.discount"
              :text="`<strong>${openPlan.discount}%</strong>&nbsp;off`"
              :color="getExperienceColor"
              class="title-badge"
            />
          </div>
          <h1 class="subtitle">{{ $t('main.purchasePlan.id.text') }}</h1>
        </div>
        <PlanContainer v-if="openPlan" :plan="openPlan" />
      </b-container>
    </section>

    <DesignBlock v-if="isDesignActive" />
    <MerchBlock v-else />

    <b-container>
      <IconsBlock />
    </b-container>

    <b-container>
      <PlanContainer v-if="openPlan" :plan="openPlan" />
    </b-container>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import DesignBlock from '@/components/PurchasePlan/DesignBlock';
import IconsBlock from '@/components/PurchasePlan/IconsBlock';
import MerchBlock from '@/components/PurchasePlan/MerchBlock';
import PlanContainer from '@/components/PurchasePlan/PlanContainer';
import Badges from '@/components/UI/Badges';

export default {
  name: 'PurchasePlan',
  components: {
    DesignBlock,
    IconsBlock,
    MerchBlock,
    PlanContainer,
    Badges
  },
  head() {
    const i18nSeo = this.$seoPlugin({ slash: true });
    return {
      title: this.$t('purchase.plans.seo.metaTitle', { number: this.$route.params.id }),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('purchase.plans.seo.metaDescription', { number: this.$route.params.id })
        },
        { hid: 'robots', name: 'robots', content: 'noindex' }
      ],
      link: [...i18nSeo.link]
    };
  },
  computed: {
    ...mapState('plans', ['openPlan']),
    ...mapGetters('experience', ['getExperienceColor', 'isDesignActive', 'getExperience'])
  },
  created() {
    this.$store.dispatch('experience/SET_USER_EXPERIENCE', this.openPlan?.experienceType);
  },
  destroyed() {
    this.$store.dispatch('experience/SET_USER_EXPERIENCE', '');
  },
  async mounted() {
    const plan = await this.$store.dispatch('plans/GET_PLAN', this.$route.params.id);
    if (plan) {
      this.$store.dispatch('plans/OPEN_PLAN', plan);
      this.$cookies.set('vx.plan', plan);

      const planExperience = plan.experienceType.toLowerCase();
      const merch = this.$store.getters['experience/getMerch'];
      const design = this.$store.getters['experience/getDesign'];

      if (planExperience === merch || planExperience === design) {
        this.$store.commit('experience/SET_USER_EXPERIENCE', planExperience);
      }
    } else {
      this.redirect(this.$urlBuilder('plans'));
    }
  }
};
</script>

<style lang="scss" scoped>
.banner-img {
  top: 0;
  left: 0;
  z-index: 0;
}
.banner-container {
  z-index: 2;
  .text-container {
    padding-top: 70px;
    color: #505050;
    .title-container {
      margin-bottom: 7px;
      display: flex;
      align-items: center;
      .title {
        font-size: 2.5rem;
        font-weight: 500;
      }
    }
    .subtitle {
      font-size: 22px;
      font-weight: 500;
    }
  }
}
.text-col {
  .title {
    font-size: 25px;
    font-weight: 400;
  }
  .subtitle {
    font-size: 15px;
  }
}
</style>
